import React from "react";
import CText from "../Components/CText";
import Avatar from "../assets/avatar.jpg";
import IntroContainer from "../Components/IntroContainer";
import { Col, Container, Row } from "reactstrap";

function HomePage() {
  return (
    <div className="homePageSection">
      <IntroContainer />
      <img alt=" image that is not loaded unfortunately" className="my-5 avatarImage" src={Avatar} />
    </div>
  );
}

export default HomePage;
